import Select from './Select'
import MultiSelect from './MultiSelect'

export { MultiSelect }

export default Select
